module.exports = __webpack_public_path__ + "img/spotonlive-logo.f524cade.svg";